import { Link } from "react-router-dom";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import React from "react";
import Cookies from "js-cookie";
// import { console } from "inspector";

function LatestBlogCard({ blog,language }) {
    // console.log("Blog Data:", blog);
    // const firstImage = blog ? blog.content.match(/<img[^>]+src="([^">]+)"/)?.[1] : null;
    const blogTitle = blog?.title || "No Title";
    // const blogExcerpt = blog?.excerpt || "No content available.";
    console.log("Blog Title:", blog);
    const isArabic = language === "ar" || Cookies.get("lang") == "ar";
    function truncateText(text, maxLength) {
        if (text?.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + '...';
    }

    let url = `inspire/${blog?.countryData?.name?.toLocaleLowerCase().replace(/\s+/g, '-')}/${blog?.slug?.toLocaleLowerCase().replace(/\s+/g, '-') || "slug"}-${blog?._id}`;
    
    return (
        <>
          {isArabic && blog?.isForArabic === "no" ? (
            <div className="absolute top-0 left-0 bg-red-500 text-white p-2 rounded-tl-xl rounded-br-xl">
              No Blogs Find
            </div>
          ) : (
            <div className="flex-none w-[90%] sm:w-[80%] md:w-[60%] lg:w-[30%] xl:w-[25%] mb-5">
              <Link
                to={isArabic ? `/ar/${url}` : `/en/${url}`}
                dir={isArabic ? "rtl" : "ltr"}
                className="block h-[350px] bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden flex flex-col"
              >
                <img
                  src={blog?.headerImage?.[0]?.thumbUrl || "/images/latestBlog.png"}
                  alt="Blog Cover"
                  className="w-full h-48 object-cover"
                />
      
                <div
                  className={`p-4 flex flex-col justify-between h-full ${
                    isArabic ? "text-right" : "text-left"
                  }`}
                >
                  <div>
                    <h3 className="font-semibold text-lg sm:text-xl mb-2">
                      {truncateText(blogTitle, 50)}
                    </h3>
                    <p
                      className="text-gray-600 text-sm sm:text-base leading-5"
                  
                    >   {truncateText(blog?.subDescription,50)}</p>
                  </div>
                </div>
              </Link>
            </div>
          )}
        </>
      );
      
}

export default LatestBlogCard;
